<template>
  <div v-if="loading" class="loading">
    <div
      class="la-ball-clip-rotate"
      :class="{ large: 'la-2x', black: 'black' }"
    >
      <div></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Loader",
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    large: {
      type: Boolean,
      default: false,
    },
    black: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
// Spinner css
@import "../assets/loadawesome.css";

.loading {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.black {
  color: black;
}
</style>
